import StartaProject from '@/components/StartaProject'
import React from 'react'
import { GetStaticProps } from 'next'
import { getWhyUsPageData  } from '@/lib/whyus';
import Image from 'next/image';
function WhyUs({initialWhyUsPageData}:any) {
    const steps = initialWhyUsPageData?.whyUsPageSetting?.whyUsSteps?.steps;
    return (
        <div className='why_us_page header_gap'>
            <section className='sp_bottom '>
                <div className="container">
                    <div className="page_title">
                        <h1 className='f54' data-aos="fade" data-aos-delay="100">{initialWhyUsPageData?.title}</h1>
                        <div className="" dangerouslySetInnerHTML={{ __html: initialWhyUsPageData?.content || '' }}></div>
                    </div>
                </div>
            </section>
            <div className="why_us_list">
                {
                    steps && steps.map((step:any,index:any)=>{
                        const stepNumber = (index + 1).toString().padStart(2, '0');
                       return(
                        <section key={index}>
                            <div className="row g-0">
                                <div className="col-lg-6">
                                    <div className="why_us_img">
                                        <Image src={step.whyUsStepImage.sourceUrl} quality={100}   alt="why us" width={1080} height={880}/>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why_us_Content">
                                        <div className="number_wrap">
                                            <span>{stepNumber}</span>
                                            <h2>{step.whyUsStepTitle}</h2>
                                        </div>
                                        <div className="why_us_content default_typo" dangerouslySetInnerHTML={{ __html: step?.whyUsStepContent || '' }}></div>
                                    </div>
                                </div>
                            </div>
                        </section>
                       )
                    })
                    
                }
                {/* <section>
                    <div className="row g-0">
                        <div className="col-lg-6">
                            <div className="why_us_img">
                                <img src="images/why-us-1.jpg" alt="why us" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why_us_Content">
                                <div className="number_wrap">
                                    <span>01</span>
                                    <h2>Discovery</h2>
                                </div>
                                <div className="why_us_content default_typo">
                                    <p>Each and every creative journey starts with our team getting to know your
                                        business, your brand and most importantly, you. This understanding
                                        serves as one of the foundational elements of all our strategy and design
                                        work to follow. Learning about your unique vision allows us to identify
                                        marketing goals and appeal to your audience before approaching any
                                        creative or conceptual design work.</p>
                                    <p>With most new web design and logo design projects, we work through a
                                        somewhat humorous questionnaire with you specifically designed to help
                                        us view your brand through your own eyes. This exercise helps us weave
                                        your personality into our creative design work to realise your vision.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="row g-0">
                        <div className="col-lg-6">
                            <div className="why_us_img">
                                <img src="images/why-us-2.jpg" alt="why us" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why_us_Content">
                                <div className="number_wrap">
                                    <span>02</span>
                                    <h2>Strategy</h2>
                                </div>
                                <div className="why_us_content default_typo">
                                    <p>We look at your top competitors to gauge their marketing efforts and
                                        understand industry-specific design queues or trends to communicate
                                        with your audience more effectively. This research helps us plan and
                                        execute any on-site search engine optimisation to ensure you’re ready to
                                        compete out of the gate.</p>
                                    <h3>Sitemapping</h3>
                                    <p>Our strategy process includes developing a sitemap to visually illustrate
                                        where each and every page within your website will live and link to each
                                        other</p>
                                    <h3>Wireframing</h3>
                                    <p>The last step before the creative phase is wireframing. This exercise helps
                                        us establish the website information architecture without any distractions.</p>
                                    <p>Once our design strategy is complete and you’re on board with the game
                                        plan, it’s time to jump into the fun part – the creative!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="row g-0">
                        <div className="col-lg-6">
                            <div className="why_us_img">
                                <img src="images/why-us-3.jpg" alt="why us" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why_us_Content">
                                <div className="number_wrap">
                                    <span>03</span>
                                    <h2>Creative Design</h2>
                                </div>
                                <div className="why_us_content default_typo">
                                    <p>The point in the project that everyone looks forward to most is design.
                                        This phase is when we begin to see all of our design strategy work come
                                        to life as polished design concepts that we share with you throughout the
                                        process to provide formative feedback and make any course corrections
                                        along the way.</p>
                                    <h3>Web Design</h3>
                                    <p>At this stage in website design projects, we review initial concept work
                                        with you before expanding the concept into the full suite of wireframes
                                        we developed together during our strategy phase. In some cases, we may
                                        take a mobile-first design approach if your existing website analytics
                                        suggest mobile as the priority device for your audience.</p>
                                    <h3>Logo Design & Branding</h3>
                                    <p>When approaching a logo design or branding exercise, we first review a
                                        series of initial design concepts. Once you have chosen an idea, we point
                                        ourselves in that direction and continue to refine the design work until
                                        final sign off.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="row g-0">
                        <div className="col-lg-6">
                            <div className="why_us_img">
                                <img src="images/why-us-4.jpg" alt="why us" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why_us_Content">
                                <div className="number_wrap">
                                    <span>04</span>
                                    <h2>Build & Test</h2>
                                </div>
                                <div className="why_us_content default_typo">
                                    <p>Once everyone is on board, and the conceptual artwork is approved, we
                                        begin to build and test the project. This phase allows everyone to
                                        experience a fully functional design and address concerns before we
                                        polish everything off for deployment.</p>
                                    <h3>Web Design</h3>
                                    <p>We host the beta website on our private development server allowing you
                                        time to experience the working prototype before rolling out the new
                                        website design to your audience. This opportunity allows us to put the
                                        website through final testing and address any bugs.</p>
                                    <h3>Logo Design & Branding</h3>
                                    <p>This phase allows us to prepare the final logo design for everyday use in
                                        your marketing and continue the brand expansion throughout any
                                        peripherals, such as social profile design or creating brand guideline
                                        documents.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="row g-0">
                        <div className="col-lg-6">
                            <div className="why_us_img">
                                <img src="images/why-us-5.jpg" alt="why us" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why_us_Content">
                                <div className="number_wrap">
                                    <span>05</span>
                                    <h2>Launch</h2>
                                </div>
                                <div className="why_us_content default_typo">
                                    <p>We migrate the new website to the production server and run it through
                                        its paces during our multi-platform user testing. Our quality assurance
                                        efforts aim to iron out any wrinkles before releasing your new website
                                        design to the world.</p>
                                    <h3>Web Design</h3>
                                    <p>In some cases, websites may behave differently from one server to
                                        another depending on variables such as server configuration or pre-
                                        installed software. During our launch process, we run through a pre-
                                        launch checklist to ensure everything is configured correctly and running
                                        smoothly.</p>
                                    <h3>Logo Design & Branding</h3>
                                    <p>There are specific guidelines and document standards that print shops,
                                        and other media providers will expect when receiving your artwork.
                                        During our pre-flight inspection, we prepare the logo design and brand
                                        materials to meet these standards to ensure you have everything you
                                        need to reproduce your brand with consistency and confidence.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="row g-0">
                        <div className="col-lg-6">
                            <div className="why_us_img">
                                <img src="images/why-us-6.jpg" alt="why us" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why_us_Content">
                                <div className="number_wrap">
                                    <span>06</span>
                                    <h2>Manage & Grow</h2>
                                </div>
                                <div className="why_us_content default_typo">
                                    <p>Many people believe a design project is finished after step five, but not us!
                                        We prepare a customised tutorial to help you manage your new website
                                        and guide you through a list of best practices for the continued search
                                        engine optimisation of your website.</p>

                                    <p>After your website is deployed, we offer monthly website health check-ins,
                                        automated 24/7 uptime monitoring and support to ensure your new
                                        marketing engine is safe, secure and reaching its full potential.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
            </div>
            <StartaProject />
        </div>
    )
}

export default WhyUs


export const getStaticProps: GetStaticProps = async () => {

    const initialWhyUsPageData = await getWhyUsPageData()

    return {
      props: {initialWhyUsPageData},
      revalidate: 60,
    }
  }